import { render, staticRenderFns } from "./PlaceSelectionUploadTab.vue?vue&type=template&id=57a00fbc&scoped=true&"
import script from "./PlaceSelectionUploadTab.vue?vue&type=script&lang=js&"
export * from "./PlaceSelectionUploadTab.vue?vue&type=script&lang=js&"
import style0 from "./PlaceSelectionUploadTab.vue?vue&type=style&index=0&id=57a00fbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a00fbc",
  null
  
)

export default component.exports